<template>
  <div id="app">
    <router-view />
    <!--<layout></layout>-->
    <!-- apiPath要改为绝对路径，否则在非首页时会404 -->
    <live2d v-if="isClient" ref="live2d" :style="style" apiPath="/live2d-static-api/indexes"
      :model="['bilibili-live/22', 'default']" :direction="direction" :size="size" home-page="https://fengling.work"
      :tips="tips"></live2d>
  </div>
</template>

<script>
import Layout from "@/views/Layout";
// import live2d from 'vue-live2d'
export default {
  name: 'App',
  components: {
    Layout,
    // 使用异步加载,否则SSR会报错
    live2d: () => import('vue-live2d')
  },

  provide() {
    return {
      reload: this.reload
    }
  },

  data() {
    return {
      isClient: false,
      isRouterAlive: true,
      direction: 'left',
      style: 'position: fixed; bottom: 0; left: 0; zIndex: 9999;',
      width: 200,
      height: 200,
      size: 300,
      maxSize: 300,
      // tips配置和实现方式可以看vue-live2d的源码
      tips: {
        copy: [{
          selector: 'document',
          texts: ['你都复制了些什么呀，转载要记得加上出处哦！']
        }],
        visibilitychange: [{
          selector: 'document',
          texts: ['哇，你终于回来了～', '欢迎回来～']
        }],
        mouseup: [{
          selector: '.vue-live2d-main',
          texts: ['你按我干啥呀？', '不要乱摸哦～', 'Emmm...']
        }],
        mouseover: [
          {
            selector: '.vue-live2d-tool .custom-fa-comment',
            texts: ['猜猜我要说些什么？', '欣赏一些有意思的短句？']
          }, {
            selector: '.vue-live2d-tool .custom-fa-user-circle',
            texts: ['想看看我的朋友们吗？']
          }, {
            selector: '.vue-live2d-tool .custom-fa-street-view',
            texts: ['变装！']
          }, {
            selector: '.vue-live2d-tool .custom-fa-camera-retro',
            texts: ['一起拍照留念？']
          },
          {
            selector: '.vue-live2d-tool .custom-fa-info-circle',
            texts: ['(＾Ｕ＾)ノ~ＹＯ 欢迎光临风铃笔记~']
          },
          {
            selector: '.vue-live2d-tool .custom-fa-times',
            texts: ['就要说再见了吗？']
          }
        ]
      },
      resizeTimer: null,
    }
  },
  mounted() {
    if (this.isBrowser()) {
      this.isClient = true;
      // 此参数只会初始化一次
      // this.tips = this.customTips
      // 监听窗口大小变化
      window.addEventListener('resize', this.handleResizeChange);
    }
  },
  beforeDestroy() {
    if (this.isBrowser()) {
      window.removeEventListener('resize', this.handleResizeChange);
    }
  },
  methods: {
    isBrowser() {
      return typeof window !== 'undefined';
    },
    handleResizeChange() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        if (window.innerWidth < 350) {
          this.size = 0;
        } else {
          this.size = Math.min(window.innerWidth / 5, this.maxSize)
        }
      }, 300);
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  },
}
</script>

<style lang="less">
body {
  margin: 0;
  padding: 0;
  height: 100vh;
  background: #fff;
}

#app {
  //font-family: Avenir, Helvetica, Arial, sans-serif;
  //-webkit-font-smoothing: antialiased;
  //-moz-osx-font-smoothing: grayscale;
  //text-align: center;
  //color: #2c3e50;
}

.main-container {
  min-height: calc(100vh - 136px);
  margin-top: 55px;
}

.el-pagination {
  white-space: pre-wrap;
}

.el-message-box {
  width: 320px;
}
</style>
